import React from 'react';
import fr from 'facet-rest';
import {
  FDBodyText, FDHeadlineText, FDStack,
} from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { ImageRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/ImageRel';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';

const metaOverrides = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => FDHeadlineText,
    _customProps: {
      size: 'sm',
    },
  }, overrideReadOnly)
  .nameOverride('content', {
    _component: () => FDBodyText,
  }, overrideReadOnly);

export const Layout = () => {
  const { resource } = useMetaLayoutContext();

  return (
    <FDStack direction="column" spacing={2}>
      <FDStack alignItems={'center'} spacing={1}>
        {resource.withRelationship(fr.relationships.image.name,
          (rel) => <ImageRel width={'35px'} rounded={false} relationship={rel} />,
          () => null)}
        <MetaControl attrName={'title'} resource={resource} metaOverrideSet={metaOverrides} />
      </FDStack>
      <MetaControl attrName={'content'} resource={resource} metaOverrideSet={metaOverrides} />
    </FDStack>
  );
};
